import {RouteConfig} from 'vue-router'
import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue'
import OrgCreate from '@/pages/Orgs/OrgCreate.vue'
import OrgList from '@/pages/Orgs/OrgList.vue'
import OrgPage from '@/pages/Orgs/OrgPage.vue'
import OrgEdit from '@/pages/Orgs/OrgEdit.vue'
import {USER_ROLE_ADMIN} from '@/constants'

// @ts-ignore
import messages from '@/lang/index';

const orgs: RouteConfig = {
  path: '/orgs',
  name: 'orgs',
  meta: {
    pageName: messages.orgs.org
  },
  component: DashboardLayout,
  redirect: '/orgs/list',
  children: [
    {
      path: 'create',
      name: 'orgCreate',
      meta: {
        pageName: messages.orgs.add_subdivision,
        access: USER_ROLE_ADMIN
      },
      component: OrgCreate,
      props: (route) => ({
        parent: route.query.parent
      })
    },
    {
      path: 'list',
      name: 'orgsList',
      meta: {
        pageName: messages.orgs.subdivisions_list
      },
      component: OrgList
    },
    {
      path: '/orgs/:id',
      name: 'orgPage',
      meta: {
        pageName: messages.orgs.subdivision_info
      },
      component: OrgPage,
      props: true
    },
    {
      path: 'edit/:id',
      name: 'orgEdit',
      meta: {
        pageName: messages.orgs.subdivision_edit,
        access: USER_ROLE_ADMIN
      },
      component: OrgEdit,
      props: true
    },
  ]
}
export default orgs